/*@ngInject*/
const FieldListController = function(fieldType, formComponentUtil) {
    this.fieldType = fieldType;

    this.isFieldHidden = function(fieldStructure) {
        let fieldInstance = fieldStructure.fieldModel,
            fieldTemplate = fieldStructure.uiField.fieldTemplate;
        return formComponentUtil.isFieldHidden(fieldInstance, fieldTemplate);
    };
};

angular.module('umFormViewer')
    .controller('fieldListController', FieldListController);
